import React,{useEffect,useState} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useGetRoles} from '../../hooks/roles/useGet'
import {useCreateUser} from '../../hooks/users/useCreate'
import {useVerifyUser} from '../../hooks/users/useGet'
import {useGetBranches} from '../../hooks/branches/useGet'
import Select from '../../components/Select'
import BarLoader from "react-spinners/BarLoader";



const ProfileUser = () => {
  // STATES
  // PAYLOAD STATE
  const [state, setState] = useState({
    login: "",
    role: 0,
    branch: 0,
    tellerId: 0,
  });
  // MISC STATE
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const {data:foundData,isSuccess:found,isError:notFound,refetch,isFetching:verifyLoading}=useVerifyUser(state.login);

  // MISC DATA
//   GET ROLES
  const { data: roles, isSuccess: gotRoles } = useGetRoles();
  const roleSelectOptions = roles?.map((item) => ({
    name: item.roleName,
    value: item.roleId,
  }));

//   GET BRANCHES
const { data: branches, isSuccess: gotBranches } = useGetBranches(1,100);
const branchSelectOptions = branches?.map((item) => ({
  name:`${item.branchCode} (${item.branchName})`,
  value: item.branchId,
}));

  // MUTATION
  const {
    mutate: createUser,
    error: createError,
    isLoading,
    isSuccess,
  } = useCreateUser(state);

  // HANDLERS
  // INPUT HANDLER
  const handleChange = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value });
  };

  // SUBMIT HANDLER
  const handleSubmit = (e) => {
    e.preventDefault();
    // REFRESH ERROR
    setError("");
    if(notFound) {
      setError("Failed to verify user / Invalid User Login")
      return
    }
    createUser();
  };

  const handleVerifyUser=()=>{ 
      refetch()
  }

  // EFFECTS
  useEffect(() => {
    if (isSuccess) {
      setSuccess("User profiled successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (createError) {
      const message = createError?.response?.data?.message;
      setError(message);
    }
  }, [createError]);




  return (
    <form className="w-full flex flex-col space-y-5" onSubmit={handleSubmit}>
      {success.length > 0 && <Success>{success}</Success>}
      {error.length > 0 && <Error>{error}</Error>}
      <div>
      <TextField
        label="User Login"
        required
        onBlur={handleVerifyUser}
        name="login"
        value={state.login}
        onChange={handleChange}
      />
      {/* {notFound==null&&found!=null&&<span>{found.name}</span>}
      {notFound!=null&&<span>{notFound?.response?.data?.message}</span>} */}
      {verifyLoading&&<BarLoader color={"#d94f00"} className="mt-2" size={30} />}
      {found&&<p className="mt-2 text-start text-sm block text-green-600 font-medium">{foundData.name}</p>}
      {notFound&&<p className="mt-2 text-start text-sm block text-red-600 font-medium">AD user not found</p>}
      </div>
      {gotBranches && (
        <Select
          name="branch"
          onChange={handleChange}
          placeholder="Select an option"
          label="Branch"
          options={branchSelectOptions}
          required
        />
      )}
       {gotRoles && (
        <Select
          name="role"
          onChange={handleChange}
          placeholder="Select an option"
          label="Role"
          options={roleSelectOptions}
          required
        />
      )}
        <TextField
        label="Teller Id"
        required
        type='number'
        step='1'
        name="tellerId"
        value={state.tellerId}
        onChange={handleChange}
      />
      <SubmitButton loading={isLoading}>Submit</SubmitButton>
    </form>
  );
};

export default ProfileUser;
